import styled from 'styled-components'
import { Button, Select } from 'components/atoms'

export const SearchBar = styled.div`
  // wrapper for inputs
  .searchbar-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: ${ (props) => props.theme.colors.weiss };
    box-shadow: 1px 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };

    &.one-row {
      padding: 12px 10px 20px;
    }

    &.multi-row {
      padding: 12px 10px 20px;

      @media ${ (props) => props.theme.breakpoints.devices.max.td } {
        padding: 10px 10px 10px;
      }
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.td } {
      flex-direction: row;
      padding: 20px;
      align-items: flex-end;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
      padding: 26px 30px 30px 30px;
    }

    .column {
      width: 100%;
      position: relative;

      &:not(:first-of-type) {
        margin-top: 20px;

        @media ${ (props) => props.theme.breakpoints.devices.min.td } {
          margin-top: 0;
          margin-left: 20px;
        }
      }

      &.query-col {
        @media ${ (props) => props.theme.breakpoints.devices.min.td } {
          flex-grow: 1;
          max-width: 462px;
        }

        @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
          button {
            width: auto;
          }
        }
      }

      &.location-col {
        @media ${ (props) => props.theme.breakpoints.devices.min.td } {
          max-width: 410px;
        }
      }

      &.button-col {
        @media ${ (props) => props.theme.breakpoints.devices.min.td } {
          width: auto;
        }
      }
    }
  }
`

export const RadiusSelect = styled(Select)`
  min-width: 120px;
  flex-grow: 1;
  flex-shrink: 0;
`

export const LocationContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
`

export const SearchButton = styled(Button).attrs(() => ({
  className: 'btn-default',
}))`
  width: 100%;
`

/* modal styles */
/** @todo this could be specific overrides for the search bar */
export const ModalRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;

  label {
    font-size: 20px;
    line-height: 1.5;
    font-weight: 300;
    margin-bottom: 15px;
  }

  > button {
    flex-basis: 25%;
    max-width: 25%;
    flex-grow: 0;
    flex-shrink: 0;
  }

  [id^='delete-query'],
  [id^='delete-location'] {
    @media ${ (props) => props.theme.breakpoints.devices.max.md } {
      width: auto;
    }
  }

  [id^='autocomplete'] {
    width: 100vw;
    height: auto;
    border: 0;
    padding: 0;
    margin-left: -10px;
  }

  [id='filter'] {
    overflow: auto;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: ${ (props) => props.theme.colors.weiss };
    z-index: ${ (props) => props.theme.zIndices.modal };
  }
`
